export const UsersEndpoints = {
    user: () => '/user',
    users: (userId: number) => `/users/${userId}`,
};
